// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../ASSETS/BACKGROUND/NoiseBgTall.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  /* background: linear-gradient(
    112.1deg,
    rgb(11, 13, 18) 11.4%,
    rgb(17, 22, 39) 70.2%
  ); */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  color: #aab5b7;
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/SCREENING/index.css"],"names":[],"mappings":"AAAA;EACE;;;;MAII;EACJ,yDAAmE;EACnE,sBAAsB;EACtB,cAAc;AAChB","sourcesContent":[".content {\n  /* background: linear-gradient(\n    112.1deg,\n    rgb(11, 13, 18) 11.4%,\n    rgb(17, 22, 39) 70.2%\n  ); */\n  background-image: url(\"./../../ASSETS/BACKGROUND/NoiseBgTall.webp\");\n  background-size: cover;\n  color: #aab5b7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
